<template>
  <el-container class="background-white">
    <el-header>
      <h1>Kitsilano Queues</h1>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="12">
          <el-switch
            v-model="autoRefresh"
            :disabled="loading"
            active-text="Auto-Refresh On"
            inactive-text="Auto-Refresh Off"></el-switch>
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button
            type="primary"
            round @click="fetchQueues"
            :disabled="loading || autoRefresh">
            Refresh
          </el-button>
        </el-col>
      </el-row>
      <el-tabs
        v-if="queues && queues.length"
        v-loading="loading"
        tab-position="top"
        @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in queues"
          :key="item.name"
          :label="item.name"
          :name="item.name">
          <span slot="label">{{item.name}} ({{item.value}})</span>
          <component
            :is="item.component"
            :name="item.name"
            :refresh="loading"/>
        </el-tab-pane>
      </el-tabs>
      <QueuesEmpty v-else/>
    </el-main>
  </el-container>
</template>

<script>
  import axios, { RepositoryError } from '../../repositories';
  import OrderInfoObjectFailedTable from './OrderInfoObjectFailedTable';
  import QueuedOrdersTable from './QueuedOrderTable';
  import ComingSoon from './ComingSoon';
  import QueuesEmpty from './QueuesEmpty';

  export default {
    name: 'KitsilanoQueuePage',
    created() {
      this.fetchQueues();
    },
    data() {
      return {
        autoRefresh: false,
        autoRefreshInterval: 10000,
        refreshInterval: null,
        loading: true,
        queues: [],
        component: null,
      };
    },
    components: {
      QueuesEmpty,
    },
    methods: {
      async fetchQueues() {
        try {
          this.loading = true;

          const response = await axios.get('/kitsilano/statistics/queues');
          const queues = response.data || [];

          this.emptyQueues();

          for (let queueName in queues) {
            this.queues.push({
              name: queueName,
              value: queues[queueName],
              component: this.componentFactory(queueName),
            });
          }
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.loading = false;
        }
      },
      emptyQueues() {
        this.queues = [];
      },
      /*
       * Only tabs with items in the queue are shown. Queues that do not have
       * an GUI implemented yet will show the 'Coming Soon' placeholder until
       * they are implemented. The list has been left in here for reference for
       * all the queues that could possibly have items. Some of the queues will
       * be deleted in the future.
       *
       * The component Factory is required for now since the queues each store
       * a different form of the order, once we have a consistent object we're
       * passing around, we will only need one component.
       */
      componentFactory(name) {
        switch (name) {
          case 'Shopify Issued Order Queue':
          case 'LogOn Failed Response Queue':
            return OrderInfoObjectFailedTable;
          case 'Queued Orders':
            return QueuedOrdersTable;
          case 'Shopify Queue':
          case 'Order Need Gift Card Redemption Queue':
          case 'Shopify Hold Order Queue':
          case 'Bundle Query Queue':
          case 'Bundle Query Issued Order Queue':
          case 'Bundle Assembly Queue':
          case 'Bundle Assembly Issued Order Queue':
          case 'LogOn Shopify Queue':
          case 'Shopify Hold Order Issue Queue':
          case 'Shopify Unsupported Region List':
            return ComingSoon;
          default:
            return ComingSoon;
        }
      },
      handleClick(tab, event) {
        this.component = this.componentFactory(tab.label);
      },
    },
    watch: {
      autoRefresh: function(val) {
        if (val) {
          return this.refreshInterval = setInterval(
            () => this.fetchQueues(),
            this.autoRefreshInterval,
          );
        }

        clearTimeout(this.refreshInterval);
      },
    },
  };
</script>
